var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.apiKey)?_c('yandex-map',{staticClass:"zones-map",attrs:{"settings":_vm.settings,"coords":_vm.mapCenter,"zoom":_vm.zoom,"controls":[]},on:{"map-was-initialized":_vm.onMapReady}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }